import { useQueryJourneys } from 'modules/quickActionsMenu/hooks';
import { useRumError } from 'services/observability/datadog';
import { Product, Team } from 'teams';

export const useJourneySearch = (search = '') => {
  const addErrorSignal = useRumError();

  const { data, isLoading } = useQueryJourneys(search, {
    onError: (error) => {
      addErrorSignal(error, 'QuickActionsMenu > useJourneySearch', {
        name: 'Quick Actions Menu journeys GraphQL query',
        productName: Product.JOURNEY_INDEX,
        teamName: Team.JOURNEY_TEAM,
      });
    },
  });

  const { info, results = [] } = data?.cmdKJourneys || {};
  return { info, journeys: results, isLoading };
};
